import React from 'react';
import { FinalCTA } from '../components/FinalCTA';
import { PageIntro } from '../components/PageIntro';
import { StayFAQ } from '../components/StayFAQ';
import { StayOnTheLand } from '../components/StayOnTheLand';
import { TrustDiscovery } from '../components/TrustDiscovery';
export function StaysPage() {
  return <>
      <PageIntro eyebrow="Stay Overnight" title="Escape to nature." description="Peaceful accommodation surrounded by trees and open space, with the sauna, hot tub and cold water a few steps from the door." data-id="element-754" data-mp="6bkp6t94admr" />
      <StayOnTheLand data-id="element-755" data-mp="y3s7dy49ty39" />
      <StayFAQ data-id="element-756" data-mp="kasp5od3tps0" />
      <TrustDiscovery data-id="element-757" data-mp="kbc91ambeo8o" />
      <FinalCTA data-id="element-758" data-mp="ka17lhgcdskq" />
    </>;
}